import React from 'react'
import PropTypes from 'prop-types'

import Interest from '@pages/Thankyou/Interest'
import AlreadyEligible from '@pages/Thankyou/AlreadyEligible'

import Success from './Greetings/Success'
import MediumCompanies from './MediumCompanies'

export default function ThankYou({ match }) {
  function resolveGreeting(origin) {
    switch (origin) {
      case 'large-companies':
        return <Interest />
      case 'contact-us':
      case 'medium-companies':
        return <MediumCompanies />
      case 'already-eligible':
        return <AlreadyEligible />
      default:
        return <Success />
    }
  }

  return resolveGreeting(match.params.origin)
}

ThankYou.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
    params: PropTypes.shape({
      origin: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
